// // // src/pages/Login.jsx
// // import React, { useMemo, useState } from "react";
// // import {
// //   Container,
// //   Row,
// //   Col,
// //   Form,
// //   Button,
// //   Alert,
// //   Spinner,
// //   Card,
// // } from "react-bootstrap";
// // import { useNavigate } from "react-router-dom";
// // import {
// //   signInWithEmailAndPassword,
// //   GoogleAuthProvider,
// //   signInWithPopup,
// // } from "firebase/auth";
// // import { auth, db } from "../firebase";
// // import {
// //   doc,
// //   getDoc,
// //   runTransaction,
// //   setDoc,
// //   Timestamp,
// // } from "firebase/firestore";
// // import "./Login.css";

// // /** ---------- Utils ---------- **/

// // /** Community */
// // const fetchCommunityById = async (communityId) => {
// //   const id = (communityId || "").trim();
// //   if (!id) throw new Error("Please enter a Community ID.");

// //   const ref = doc(db, "communities", id);
// //   const snap = await getDoc(ref);
// //   if (!snap.exists()) {
// //     const err = new Error("Community not found. Check the ID and try again.");
// //     err.code = "community/not-found";
// //     throw err;
// //   }
// //   return { id, data: snap.data() };
// // };

// // /** User profile */
// // const fetchUserProfile = async (uid) => {
// //   const ref = doc(db, "users", uid);
// //   const snap = await getDoc(ref);
// //   return snap.exists() ? { id: uid, ...snap.data() } : null;
// // };

// // /** floor/flat helpers */
// // const deriveFromStartNumber = (startNumberInput) => {
// //   const s = String(startNumberInput || "").replace(/\D/g, "");
// //   if (!s) return { floorBase: 1, indexStart: 1, indexWidth: 2 };
// //   if (s.length <= 2) {
// //     const indexStart = parseInt(s, 10);
// //     const indexWidth = Math.max(2, s.length);
// //     return { floorBase: 1, indexStart, indexWidth };
// //   }
// //   const floorBase = parseInt(s.slice(0, -2), 10);
// //   const indexStart = parseInt(s.slice(-2), 10);
// //   return { floorBase, indexStart, indexWidth: 2 };
// // };

// // const buildFloorLabels = (block) => {
// //   if (!block || typeof block !== "object") return [];
// //   const labels = [];
// //   if (block.hasGround)
// //     labels.push({ label: `Ground (${block.groundLabel})`, floorNumber: 0 });
// //   for (let f = 1; f <= Number(block.floors || 0); f++) {
// //     labels.push({ label: `Floor ${f}`, floorNumber: f });
// //   }
// //   return labels;
// // };

// // const buildFlatsForFloor = (block, floorNumber) => {
// //   const { floorBase, indexStart, indexWidth } = deriveFromStartNumber(
// //     block.startNumberInput || "101"
// //   );
// //   const count = Number(block.flatsPerFloor || 0);
// //   const out = [];

// //   if (floorNumber === 0) {
// //     for (let i = 0; i < count; i++) {
// //       const idx = indexStart + i;
// //       out.push(
// //         `${block.name}-${block.groundLabel}${String(idx).padStart(
// //           indexWidth,
// //           "0"
// //         )}`
// //       );
// //     }
// //     return out;
// //   }

// //   const floorCode = floorBase + (floorNumber - 1);
// //   for (let i = 0; i < count; i++) {
// //     const idx = indexStart + i;
// //     out.push(
// //       `${block.name}-${floorCode}${String(idx).padStart(indexWidth, "0")}`
// //     );
// //   }
// //   return out;
// // };

// // /** ---------- Component ---------- **/

// // export default function Login() {
// //   // Step 1: Community
// //   const [communityId, setCommunityId] = useState("");
// //   const [community, setCommunity] = useState(null);
// //   const [fetching, setFetching] = useState(false);
// //   const [fetchError, setFetchError] = useState("");

// //   // Step 2: Login toggle
// //   const [showLoginForm, setShowLoginForm] = useState(false);

// //   // Step 2: Login fields
// //   const [email, setEmail] = useState("");
// //   const [password, setPassword] = useState("");
// //   const [loginError, setLoginError] = useState("");
// //   const [loggingIn, setLoggingIn] = useState(false);

// //   // Profile completion state
// //   const [profile, setProfile] = useState(null); // loaded user profile after auth
// //   const [needsCompletion, setNeedsCompletion] = useState(false);

// //   // Completion form state
// //   const [selectedBlockId, setSelectedBlockId] = useState("");
// //   const [selectedFloorNumber, setSelectedFloorNumber] = useState(null);
// //   const [selectedFlatLabel, setSelectedFlatLabel] = useState("");
// //   const [availableFlats, setAvailableFlats] = useState([]);
// //   const [availLoading, setAvailLoading] = useState(false);
// //   const [fullName, setFullName] = useState("");
// //   const [mobile, setMobile] = useState("");
// //   const [confirmInfo, setConfirmInfo] = useState(false);
// //   const [savingProfile, setSavingProfile] = useState(false);
// //   const [completionError, setCompletionError] = useState("");

// //   const navigate = useNavigate();

// //   const blocks = useMemo(() => {
// //     if (!community?.data?.blocks || !Array.isArray(community.data.blocks))
// //       return [];
// //     return community.data.blocks;
// //   }, [community]);

// //   // compute floorOptions at the top-level (unconditional)
// //   const floorOptions = useMemo(() => {
// //     const block = blocks.find((b) => b.id === selectedBlockId);
// //     if (!block) return [];
// //     return buildFloorLabels(block);
// //   }, [blocks, selectedBlockId]);

// //   const handleFetch = async (e) => {
// //     e?.preventDefault?.();
// //     setFetchError("");
// //     setCommunity(null);
// //     setShowLoginForm(false);
// //     setLoginError("");

// //     const id = communityId.trim();
// //     if (!id) {
// //       setFetchError("Please enter a Community ID.");
// //       return;
// //     }

// //     try {
// //       setFetching(true);
// //       const result = await fetchCommunityById(id);
// //       setCommunity(result);
// //     } catch (err) {
// //       console.error("Fetch community error:", err.code, err.message);
// //       setFetchError(err.message || "Unable to fetch community.");
// //     } finally {
// //       setFetching(false);
// //     }
// //   };

// //   const handleProceedToLogin = () => {
// //     setShowLoginForm(true);
// //     setLoginError("");
// //   };

// //   /** Refresh flats availability for selected floor */
// //   const refreshAvailableFlats = async () => {
// //     setAvailableFlats([]);
// //     setSelectedFlatLabel("");
// //     setAvailLoading(true);
// //     try {
// //       const block = blocks.find((b) => b.id === selectedBlockId);
// //       if (!block || selectedFloorNumber === null) return;

// //       const all = buildFlatsForFloor(block, selectedFloorNumber);
// //       const occupancy = block.occupancy || {};
// //       const avail = all.filter((label) => !occupancy[label]);
// //       setAvailableFlats(avail);
// //     } finally {
// //       setAvailLoading(false);
// //     }
// //   };

// //   /** After login (email or Google), decide where to send the user */
// //   const routeOrRequireCompletion = async (authedUser) => {
// //     const id = communityId.trim();
// //     const userDoc = await fetchUserProfile(authedUser.uid);

// //     if (!userDoc) {
// //       const newDoc = {
// //         uid: authedUser.uid,
// //         role: authedUser.role,
// //         email: authedUser.email || "",
// //         fullName: authedUser.displayName || null,
// //         mobile: null,
// //         status: "incomplete",
// //         profileCompleted: false,
// //         pendingCommunityId: id,
// //         communities: [],
// //         authProvider: authedUser.providerData?.[0]?.providerId || "unknown",
// //         createdAt: Timestamp.now(),
// //       };
// //       await setDoc(doc(db, "users", authedUser.uid), newDoc, { merge: true });
// //       setProfile(newDoc);
// //       setFullName(newDoc.fullName || "");
// //       setNeedsCompletion(true);
// //       return;
// //     }

// //     setProfile(userDoc);
// //     setFullName((userDoc.fullName || authedUser.displayName || "").trim());
// //     setMobile(userDoc.mobile || "");

// //     const role = String(userDoc.role || "resident").toLowerCase();
// //     const belongs =
// //       Array.isArray(userDoc.communities) && userDoc.communities.includes(id);
// //     const hasUnit = !!userDoc.unit && !!userDoc.unit.flatLabel;
// //     const completed = userDoc.profileCompleted === true;

// //     if (role === "admin") return navigate("/admin-dashboard");
// //     if (role === "manager") return navigate(`/manager/${id}`);
// //     if (role === "employee") return navigate(`/employee/${id}`);
// //     if (role === "resident" && belongs && hasUnit && completed) {
// //       return navigate(`/resident/${id}`);
// //     }

// //     await setDoc(
// //       doc(db, "users", authedUser.uid),
// //       {
// //         pendingCommunityId: id,
// //         profileCompleted: false,
// //         status: "incomplete",
// //       },
// //       { merge: true }
// //     );
// //     setNeedsCompletion(true);
// //   };

// //   /** Email/password login */
// //   const handleLogin = async (e) => {
// //     e?.preventDefault?.();
// //     setLoginError("");
// //     setCompletionError("");
// //     setNeedsCompletion(false);

// //     if (!community) {
// //       setLoginError("Please fetch and confirm your community first.");
// //       return;
// //     }
// //     if (!email || !password) {
// //       setLoginError("Please enter email and password.");
// //       return;
// //     }

// //     try {
// //       setLoggingIn(true);
// //       const { user } = await signInWithEmailAndPassword(
// //         auth,
// //         email.trim(),
// //         password
// //       );
// //       await routeOrRequireCompletion(user);
// //     } catch (err) {
// //       console.error("Login error:", err.code, err.message);
// //       setLoginError(err.message || "Login failed. Try again.");
// //     } finally {
// //       setLoggingIn(false);
// //     }
// //   };

// //   /** Google login */
// //   const handleGoogleLogin = async () => {
// //     setLoginError("");
// //     setCompletionError("");
// //     setNeedsCompletion(false);

// //     if (!community) {
// //       setLoginError("Please fetch and confirm your community first.");
// //       return;
// //     }

// //     try {
// //       setLoggingIn(true);
// //       const provider = new GoogleAuthProvider();
// //       provider.setCustomParameters({ prompt: "select_account" });
// //       const result = await signInWithPopup(auth, provider);
// //       const user = result.user;
// //       await routeOrRequireCompletion(user);
// //     } catch (err) {
// //       console.error("Google sign-in error:", err.code, err.message);
// //       setLoginError(err.message || "Google sign-in failed. Please try again.");
// //     } finally {
// //       setLoggingIn(false);
// //     }
// //   };

// //   /** Save profile completion (claim flat + write profile) */
// //   const handleCompleteProfile = async () => {
// //     setCompletionError("");

// //     if (!auth.currentUser) return setCompletionError("You are not signed in.");
// //     if (!community?.id) return setCompletionError("Community not loaded.");
// //     if (!selectedBlockId) return setCompletionError("Please select a block.");
// //     if (selectedFloorNumber === null)
// //       return setCompletionError("Please select a floor.");
// //     if (!selectedFlatLabel) return setCompletionError("Please select a flat.");
// //     if (!confirmInfo)
// //       return setCompletionError("Please confirm the information is correct.");

// //     const block = blocks.find((b) => b.id === selectedBlockId);
// //     if (!block) return setCompletionError("Invalid block selection.");

// //     try {
// //       setSavingProfile(true);

// //       // 1) Claim flat in a transaction
// //       const communityRef = doc(db, "communities", community.id);
// //       await runTransaction(db, async (t) => {
// //         const snap = await t.get(communityRef);
// //         if (!snap.exists())
// //           throw new Error("Community not found during claim.");
// //         const data = snap.data();
// //         const blocksArr = Array.isArray(data.blocks) ? [...data.blocks] : [];
// //         const idx = blocksArr.findIndex((b) => b.id === selectedBlockId);
// //         if (idx < 0) throw new Error("Selected block not found.");

// //         const target = { ...blocksArr[idx] };
// //         const occupancy = { ...(target.occupancy || {}) };
// //         if (occupancy[selectedFlatLabel]) {
// //           throw new Error(
// //             "Selected flat is already occupied. Please choose another flat."
// //           );
// //         }

// //         occupancy[selectedFlatLabel] = auth.currentUser.uid;
// //         target.occupancy = occupancy;
// //         blocksArr[idx] = target;

// //         t.update(communityRef, { blocks: blocksArr });
// //       });

// //       // 2) Merge user profile
// //       const userRef = doc(db, "users", auth.currentUser.uid);
// //       const userSnap = await getDoc(userRef);
// //       const existing = userSnap.exists() ? userSnap.data() : {};
// //       const communities = Array.isArray(existing.communities)
// //         ? Array.from(new Set([...(existing.communities || []), community.id]))
// //         : [community.id];

// //       await setDoc(
// //         userRef,
// //         {
// //           uid: auth.currentUser.uid,
// //           role: "resident",
// //           email: auth.currentUser.email || existing.email || "",
// //           fullName: (fullName || existing.fullName || "").trim() || null,
// //           mobile: (mobile || existing.mobile || "").trim() || null,
// //           communities,
// //           unit: {
// //             communityId: community.id,
// //             blockName: block.name,
// //             floorNumber: selectedFloorNumber,
// //             flatLabel: selectedFlatLabel,
// //           },
// //           status: "pending",
// //           profileCompleted: true,
// //           pendingCommunityId: null,
// //           authProvider:
// //             auth.currentUser.providerData?.[0]?.providerId || "unknown",
// //           createdAt: existing.createdAt || Timestamp.now(),
// //         },
// //         { merge: true }
// //       );

// //       setNeedsCompletion(false);
// //       navigate(`/resident/${community.id}`);
// //     } catch (err) {
// //       console.error("Profile completion error:", err.code, err.message);
// //       setCompletionError(
// //         err.message || "Could not save your details. Please try again."
// //       );
// //     } finally {
// //       setSavingProfile(false);
// //     }
// //   };

// //   /** Reset */
// //   const resetCommunity = () => {
// //     setCommunity(null);
// //     setCommunityId("");
// //     setFetchError("");
// //     setShowLoginForm(false);
// //     setEmail("");
// //     setPassword("");
// //     setLoginError("");

// //     // reset completion section
// //     setProfile(null);
// //     setNeedsCompletion(false);
// //     setSelectedBlockId("");
// //     setSelectedFloorNumber(null);
// //     setSelectedFlatLabel("");
// //     setAvailableFlats([]);
// //     setFullName("");
// //     setMobile("");
// //     setConfirmInfo(false);
// //     setCompletionError("");
// //   };

// //   return (
// //     <Container fluid className="min-vh-100">
// //       <Row className="g-0 min-vh-60">
// //         {/* LEFT visual (now visible on mobile as a top banner) */}
// //         <Col
// //           xs={12}
// //           md={6}
// //           className="login-hero d-flex align-items-center justify-content-center position-relative"
// //         >
// //           <div className="login-hero-overlay" aria-hidden="true" />
// //           <div className="position-relative text-center text-white px-4">
// //             <i className="bi bi-shield-lock-fill fs-1 mb-3 d-block"></i>
// //             <h2 className="fw-bold">Secure Community Login</h2>
// //             <p
// //               className="text-white-50 mx-auto hero-sub"
// //               style={{ maxWidth: 520 }}
// //             >
// //               Verify your community, then sign in to access resident services.
// //             </p>
// //           </div>
// //         </Col>

// //         {/* RIGHT forms */}
// //         <Col
// //           xs={12}
// //           md={6}
// //           className="d-flex align-items-center justify-content-center py-4 py-md-5 bg-light"
// //         >
// //           <div className="w-100" style={{ maxWidth: 560 }}>
// //             {/* Mobile title (optional, you can remove since hero is now visible) */}
// //             {/* <div className="mb-4 text-center d-md-none">
// //               <i className="bi bi-shield-lock-fill fs-2 d-block"></i>
// //               <h2 className="fw-bold mt-2">Secure Community Login</h2>
// //               <p className="text-muted mb-0">Identify your community, then sign in.</p>
// //             </div> */}

// //             {/* Step 1: Community */}
// //             <Card className="shadow-sm">
// //               <Card.Header className="fw-semibold">
// //                 Step 1: Identify Your Community
// //               </Card.Header>
// //               <Card.Body>
// //                 {fetchError && <Alert variant="danger">{fetchError}</Alert>}

// //                 {!community ? (
// //                   <Form onSubmit={handleFetch}>
// //                     <Form.Group className="mb-3">
// //                       <Form.Label>Community ID</Form.Label>
// //                       <Form.Control
// //                         type="text"
// //                         placeholder="e.g., AVC12345"
// //                         value={communityId}
// //                         onChange={(e) =>
// //                           setCommunityId(e.target.value.toUpperCase())
// //                         }
// //                         autoFocus
// //                       />
// //                     </Form.Group>

// //                     <div className="d-grid">
// //                       <Button
// //                         className="btn-primary-navbar-reg"
// //                         type="submit"
// //                         disabled={fetching}
// //                       >
// //                         {fetching ? (
// //                           <>
// //                             <Spinner
// //                               animation="border"
// //                               size="sm"
// //                               className="me-2"
// //                             />
// //                             Fetching…
// //                           </>
// //                         ) : (
// //                           "Fetch"
// //                         )}
// //                       </Button>
// //                     </div>

// //                     <p
// //                       className="register-link mt-3"
// //                       onClick={() => navigate("/register")}
// //                       style={{ cursor: "pointer" }}
// //                     >
// //                       Register
// //                     </p>
// //                   </Form>
// //                 ) : (
// //                   <>
// //                     <Alert variant="info">
// //                       <div>
// //                         <strong>Community ID:</strong>{" "}
// //                         <code>{communityId}</code>
// //                       </div>
// //                       <div>
// //                         <strong>Name: {community.data.name}</strong>
// //                       </div>
// //                       <div>
// //                         <strong>Address:</strong> {community.data.address}
// //                       </div>
// //                       {/* {community.data.description && (
// //                         <div>
// //                           <strong>Description:</strong> {community.data.description}
// //                         </div>
// //                       )} */}
// //                     </Alert>
// //                     <div className="d-flex flex-wrap gap-2">
// //                       <Button
// //                         variant="outline-secondary"
// //                         onClick={resetCommunity}
// //                       >
// //                         Check another Community
// //                       </Button>
// //                       <Button
// //                         variant="primary"
// //                         className="btn-primary-navbar-reg"
// //                         onClick={handleProceedToLogin}
// //                       >
// //                         Proceed to Login
// //                       </Button>
// //                     </div>
// //                   </>
// //                 )}
// //               </Card.Body>
// //             </Card>

// //             {/* Step 2: Login */}
// //             {community && showLoginForm && !needsCompletion && (
// //               <Card className="mt-3 shadow-sm">
// //                 <Card.Header className="fw-semibold">
// //                   Step 2: Sign In
// //                 </Card.Header>
// //                 <Card.Body>
// //                   {loginError && <Alert variant="danger">{loginError}</Alert>}

// //                   <div className="d-grid gap-2 mb-3">
// //                     <Button
// //                       variant="outline-danger"
// //                       onClick={handleGoogleLogin}
// //                       disabled={loggingIn}
// //                     >
// //                       {loggingIn ? (
// //                         <>
// //                           <Spinner
// //                             animation="border"
// //                             size="sm"
// //                             className="me-2"
// //                           />
// //                           Signing in…
// //                         </>
// //                       ) : (
// //                         "Continue with Google"
// //                       )}
// //                     </Button>
// //                   </div>

// //                   <div className="text-center text-muted my-2">or</div>

// //                   <Form onSubmit={handleLogin}>
// //                     <Form.Group className="mb-3">
// //                       <Form.Label>Email</Form.Label>
// //                       <Form.Control
// //                         type="email"
// //                         autoComplete="username"
// //                         placeholder="name@example.com"
// //                         value={email}
// //                         onChange={(e) => setEmail(e.target.value)}
// //                         disabled={!community}
// //                       />
// //                     </Form.Group>

// //                     <Form.Group className="mb-3">
// //                       <Form.Label>Password</Form.Label>
// //                       <Form.Control
// //                         type="password"
// //                         autoComplete="current-password"
// //                         placeholder="••••••••"
// //                         value={password}
// //                         onChange={(e) => setPassword(e.target.value)}
// //                         disabled={!community}
// //                       />
// //                     </Form.Group>

// //                     <div className="d-grid">
// //                       <Button
// //                         className="btn-primary-navbar-reg"
// //                         type="submit"
// //                         disabled={!community || loggingIn}
// //                       >
// //                         {loggingIn ? (
// //                           <>
// //                             <Spinner
// //                               animation="border"
// //                               size="sm"
// //                               className="me-2"
// //                             />
// //                             Signing in…
// //                           </>
// //                         ) : (
// //                           "Login"
// //                         )}
// //                       </Button>
// //                     </div>
// //                   </Form>
// //                 </Card.Body>
// //               </Card>
// //             )}

// //             {/* Step 3: Complete Profile */}
// //             {community && needsCompletion && (
// //               <Card className="mt-3 shadow-sm">
// //                 <Card.Header className="fw-semibold">
// //                   Complete your profile
// //                 </Card.Header>
// //                 <Card.Body>
// //                   <Alert variant="warning" className="mb-3">
// //                     Please complete your unit details to finish setup for this
// //                     community.
// //                   </Alert>

// //                   {completionError && (
// //                     <Alert variant="danger">{completionError}</Alert>
// //                   )}

// //                   <Row className="g-2">
// //                     {/* Block */}
// //                     <Form.Group as={Col} xs={12} md={4} className="mb-3">
// //                       <Form.Label>Block</Form.Label>
// //                       <Form.Select
// //                         value={selectedBlockId}
// //                         onChange={(e) => {
// //                           setSelectedBlockId(e.target.value);
// //                           setSelectedFloorNumber(null);
// //                           setSelectedFlatLabel("");
// //                           setAvailableFlats([]);
// //                         }}
// //                       >
// //                         <option value="">Select block</option>
// //                         {blocks.map((b) => (
// //                           <option key={b.id} value={b.id}>
// //                             {b.name} - Block
// //                           </option>
// //                         ))}
// //                       </Form.Select>
// //                     </Form.Group>

// //                     {/* Floor */}
// //                     <Form.Group as={Col} xs={12} md={4} className="mb-3">
// //                       <Form.Label>Floor</Form.Label>
// //                       <Form.Select
// //                         value={selectedFloorNumber ?? ""}
// //                         disabled={!selectedBlockId}
// //                         onChange={(e) => {
// //                           const val =
// //                             e.target.value === ""
// //                               ? null
// //                               : Number(e.target.value);
// //                           setSelectedFloorNumber(val);
// //                           setSelectedFlatLabel("");
// //                           setAvailableFlats([]);
// //                         }}
// //                         onBlur={refreshAvailableFlats}
// //                         onFocus={() => {
// //                           if (selectedBlockId && selectedFloorNumber !== null)
// //                             refreshAvailableFlats();
// //                         }}
// //                       >
// //                         <option value="">Select floor</option>
// //                         {floorOptions.map(({ label, floorNumber }) => (
// //                           <option
// //                             key={`floor-${floorNumber}`}
// //                             value={floorNumber}
// //                           >
// //                             {label}
// //                           </option>
// //                         ))}
// //                       </Form.Select>
// //                       <Form.Text muted>
// //                         Ground availability uses the same numbering pattern as
// //                         upper floors.
// //                       </Form.Text>
// //                     </Form.Group>

// //                     {/* Flat */}
// //                     <Form.Group as={Col} xs={12} md={4} className="mb-3">
// //                       <Form.Label>Flat number</Form.Label>
// //                       <Form.Select
// //                         value={selectedFlatLabel}
// //                         disabled={
// //                           !selectedBlockId || selectedFloorNumber === null
// //                         }
// //                         onFocus={refreshAvailableFlats}
// //                         onChange={(e) => setSelectedFlatLabel(e.target.value)}
// //                       >
// //                         <option value="">
// //                           {availLoading
// //                             ? "Checking availability…"
// //                             : "Select available flat"}
// //                         </option>
// //                         {!availLoading &&
// //                           availableFlats.map((label) => (
// //                             <option key={label} value={label}>
// //                               {label}
// //                             </option>
// //                           ))}
// //                       </Form.Select>
// //                     </Form.Group>
// //                   </Row>

// //                   <hr />

// //                   <Form.Group className="mb-3">
// //                     <Form.Label>Full name</Form.Label>
// //                     <Form.Control
// //                       type="text"
// //                       value={fullName}
// //                       onChange={(e) => setFullName(e.target.value)}
// //                       placeholder="e.g., Rahul Sharma"
// //                     />
// //                   </Form.Group>

// //                   <Form.Group className="mb-3">
// //                     <Form.Label>Mobile</Form.Label>
// //                     <Form.Control
// //                       type="text"
// //                       value={mobile}
// //                       onChange={(e) => setMobile(e.target.value)}
// //                       placeholder="e.g., 9876543210"
// //                     />
// //                   </Form.Group>

// //                   <Form.Group className="mb-3">
// //                     <Form.Check
// //                       id="confirm-info"
// //                       type="checkbox"
// //                       label="I confirm that the above unit details and my information are correct."
// //                       checked={confirmInfo}
// //                       onChange={(e) => setConfirmInfo(e.target.checked)}
// //                     />
// //                   </Form.Group>

// //                   <div className="d-grid">
// //                     <Button
// //                       variant="primary"
// //                       onClick={handleCompleteProfile}
// //                       disabled={savingProfile}
// //                     >
// //                       {savingProfile ? (
// //                         <>
// //                           <Spinner
// //                             animation="border"
// //                             size="sm"
// //                             className="me-2"
// //                           />
// //                           Saving…
// //                         </>
// //                       ) : (
// //                         "Submit & Continue"
// //                       )}
// //                     </Button>
// //                   </div>
// //                 </Card.Body>
// //               </Card>
// //             )}
// //           </div>
// //         </Col>
// //       </Row>
// //     </Container>
// //   );
// // }

// // // ///////////////////////////////////////////////////////////////////////////////
// // // above code login with fetching the community id
// // // ///////////////////////////////////////////////////////////////////////////////

// // src/pages/Login.jsx
// import React, { useMemo, useState } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
//   Alert,
//   Spinner,
//   Card,
// } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import {
//   signInWithEmailAndPassword,
//   GoogleAuthProvider,
//   signInWithPopup,
// } from "firebase/auth";
// import { auth, db } from "../firebase";
// import {
//   doc,
//   getDoc,
//   runTransaction,
//   setDoc,
//   Timestamp,
// } from "firebase/firestore";
// import "./Login.css";

// /** ---------- Utils ---------- **/

// /** Community */
// const fetchCommunityById = async (communityId) => {
//   const id = (communityId || "").trim();
//   if (!id) throw new Error("Please enter a Community ID.");

//   const ref = doc(db, "communities", id);
//   const snap = await getDoc(ref);
//   if (!snap.exists()) {
//     const err = new Error("Community not found. Check the ID and try again.");
//     err.code = "community/not-found";
//     throw err;
//   }
//   return { id, data: snap.data() };
// };

// /** User profile */
// const fetchUserProfile = async (uid) => {
//   const ref = doc(db, "users", uid);
//   const snap = await getDoc(ref);
//   return snap.exists() ? { id: uid, ...snap.data() } : null;
// };

// /** floor/flat helpers */
// const deriveFromStartNumber = (startNumberInput) => {
//   const s = String(startNumberInput || "").replace(/\D/g, "");
//   if (!s) return { floorBase: 1, indexStart: 1, indexWidth: 2 };
//   if (s.length <= 2) {
//     const indexStart = parseInt(s, 10);
//     const indexWidth = Math.max(2, s.length);
//     return { floorBase: 1, indexStart, indexWidth };
//   }
//   const floorBase = parseInt(s.slice(0, -2), 10);
//   const indexStart = parseInt(s.slice(-2), 10);
//   return { floorBase, indexStart, indexWidth: 2 };
// };

// const buildFloorLabels = (block) => {
//   if (!block || typeof block !== "object") return [];
//   const labels = [];
//   if (block.hasGround)
//     labels.push({ label: `Ground (${block.groundLabel})`, floorNumber: 0 });
//   for (let f = 1; f <= Number(block.floors || 0); f++) {
//     labels.push({ label: `Floor ${f}`, floorNumber: f });
//   }
//   return labels;
// };

// const buildFlatsForFloor = (block, floorNumber) => {
//   const { floorBase, indexStart, indexWidth } = deriveFromStartNumber(
//     block.startNumberInput || "101"
//   );
//   const count = Number(block.flatsPerFloor || 0);
//   const out = [];

//   if (floorNumber === 0) {
//     for (let i = 0; i < count; i++) {
//       const idx = indexStart + i;
//       out.push(
//         `${block.name}-${block.groundLabel}${String(idx).padStart(
//           indexWidth,
//           "0"
//         )}`
//       );
//     }
//     return out;
//   }

//   const floorCode = floorBase + (floorNumber - 1);
//   for (let i = 0; i < count; i++) {
//     const idx = indexStart + i;
//     out.push(
//       `${block.name}-${floorCode}${String(idx).padStart(indexWidth, "0")}`
//     );
//   }
//   return out;
// };

// /** ---------- Component ---------- **/

// export default function Login() {
//   // Step 1: Community
//   const [communityId, setCommunityId] = useState("");
//   const [community, setCommunity] = useState(null);
//   const [fetching, setFetching] = useState(false);
//   const [fetchError, setFetchError] = useState("");

//   // Step 2: Login toggle
//   const [showLoginForm, setShowLoginForm] = useState(false);

//   // Step 2: Login fields
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loginError, setLoginError] = useState("");
//   const [loggingIn, setLoggingIn] = useState(false);

//   // Profile completion state
//   const [profile, setProfile] = useState(null); // loaded user profile after auth
//   const [needsCompletion, setNeedsCompletion] = useState(false);

//   // Completion form state
//   const [selectedBlockId, setSelectedBlockId] = useState("");
//   const [selectedFloorNumber, setSelectedFloorNumber] = useState(null);
//   const [selectedFlatLabel, setSelectedFlatLabel] = useState("");
//   const [availableFlats, setAvailableFlats] = useState([]);
//   const [availLoading, setAvailLoading] = useState(false);
//   const [fullName, setFullName] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [confirmInfo, setConfirmInfo] = useState(false);
//   const [savingProfile, setSavingProfile] = useState(false);
//   const [completionError, setCompletionError] = useState("");

//   const navigate = useNavigate();

//   const blocks = useMemo(() => {
//     if (!community?.data?.blocks || !Array.isArray(community.data.blocks))
//       return [];
//     return community.data.blocks;
//   }, [community]);

//   // compute floorOptions at the top-level (unconditional)
//   const floorOptions = useMemo(() => {
//     const block = blocks.find((b) => b.id === selectedBlockId);
//     if (!block) return [];
//     return buildFloorLabels(block);
//   }, [blocks, selectedBlockId]);

//   const handleFetch = async (e) => {
//     e?.preventDefault?.();
//     setFetchError("");
//     setCommunity(null);
//     setShowLoginForm(false);
//     setLoginError("");

//     const id = communityId.trim();
//     if (!id) {
//       setFetchError("Please enter a Community ID.");
//       return;
//     }

//     try {
//       setFetching(true);
//       const result = await fetchCommunityById(id);
//       setCommunity(result);
//     } catch (err) {
//       console.error("Fetch community error:", err.code, err.message);
//       setFetchError(err.message || "Unable to fetch community.");
//     } finally {
//       setFetching(false);
//     }
//   };

//   const handleProceedToLogin = () => {
//     setShowLoginForm(true);
//     setLoginError("");
//   };

//   /** Refresh flats availability for selected floor */
//   const refreshAvailableFlats = async () => {
//     setAvailableFlats([]);
//     setSelectedFlatLabel("");
//     setAvailLoading(true);
//     try {
//       const block = blocks.find((b) => b.id === selectedBlockId);
//       if (!block || selectedFloorNumber === null) return;

//       const all = buildFlatsForFloor(block, selectedFloorNumber);
//       const occupancy = block.occupancy || {};
//       const avail = all.filter((label) => !occupancy[label]);
//       setAvailableFlats(avail);
//     } finally {
//       setAvailLoading(false);
//     }
//   };

//   /** After login (email or Google), decide where to send the user */
//   const routeOrRequireCompletion = async (authedUser) => {
//     const id = communityId.trim();
//     const userDoc = await fetchUserProfile(authedUser.uid);

//     if (!userDoc) {
//       const newDoc = {
//         uid: authedUser.uid,
//         role: authedUser.role,
//         email: authedUser.email || "",
//         fullName: authedUser.displayName || null,
//         mobile: null,
//         status: "incomplete",
//         profileCompleted: false,
//         pendingCommunityId: id,
//         communities: [],
//         authProvider: authedUser.providerData?.[0]?.providerId || "unknown",
//         createdAt: Timestamp.now(),
//       };
//       await setDoc(doc(db, "users", authedUser.uid), newDoc, { merge: true });
//       setProfile(newDoc);
//       setFullName(newDoc.fullName || "");
//       setNeedsCompletion(true);
//       return;
//     }

//     setProfile(userDoc);
//     setFullName((userDoc.fullName || authedUser.displayName || "").trim());
//     setMobile(userDoc.mobile || "");

//     const role = String(userDoc.role || "resident").toLowerCase();
//     const belongs =
//       Array.isArray(userDoc.communities) && userDoc.communities.includes(id);
//     const hasUnit = !!userDoc.unit && !!userDoc.unit.flatLabel;
//     const completed = userDoc.profileCompleted === true;

//     if (role === "admin") return navigate("/admin-dashboard");
//     if (role === "manager") return navigate(`/manager/${id}`);
//     if (role === "employee") return navigate(`/employee/${id}`);
//     if (role === "resident" && belongs && hasUnit && completed) {
//       return navigate(`/resident/${id}`);
//     }

//     await setDoc(
//       doc(db, "users", authedUser.uid),
//       {
//         pendingCommunityId: id,
//         profileCompleted: false,
//         status: "incomplete",
//       },
//       { merge: true }
//     );
//     setNeedsCompletion(true);
//   };

//   /** Email/password login */
//   const handleLogin = async (e) => {
//     e?.preventDefault?.();
//     setLoginError("");
//     setCompletionError("");
//     setNeedsCompletion(false);

//     if (!community) {
//       setLoginError("Please fetch and confirm your community first.");
//       return;
//     }
//     if (!email || !password) {
//       setLoginError("Please enter email and password.");
//       return;
//     }

//     try {
//       setLoggingIn(true);
//       const { user } = await signInWithEmailAndPassword(
//         auth,
//         email.trim(),
//         password
//       );
//       await routeOrRequireCompletion(user);
//     } catch (err) {
//       console.error("Login error:", err.code, err.message);
//       setLoginError(err.message || "Login failed. Try again.");
//     } finally {
//       setLoggingIn(false);
//     }
//   };

//   /** Google login */
//   const handleGoogleLogin = async () => {
//     setLoginError("");
//     setCompletionError("");
//     setNeedsCompletion(false);

//     if (!community) {
//       setLoginError("Please fetch and confirm your community first.");
//       return;
//     }

//     try {
//       setLoggingIn(true);
//       const provider = new GoogleAuthProvider();
//       provider.setCustomParameters({ prompt: "select_account" });
//       const result = await signInWithPopup(auth, provider);
//       const user = result.user;
//       await routeOrRequireCompletion(user);
//     } catch (err) {
//       console.error("Google sign-in error:", err.code, err.message);
//       setLoginError(err.message || "Google sign-in failed. Please try again.");
//     } finally {
//       setLoggingIn(false);
//     }
//   };

//   /** Save profile completion (claim flat + write profile) */
//   const handleCompleteProfile = async () => {
//     setCompletionError("");

//     if (!auth.currentUser) return setCompletionError("You are not signed in.");
//     if (!community?.id) return setCompletionError("Community not loaded.");
//     if (!selectedBlockId) return setCompletionError("Please select a block.");
//     if (selectedFloorNumber === null)
//       return setCompletionError("Please select a floor.");
//     if (!selectedFlatLabel) return setCompletionError("Please select a flat.");
//     if (!confirmInfo)
//       return setCompletionError("Please confirm the information is correct.");

//     const block = blocks.find((b) => b.id === selectedBlockId);
//     if (!block) return setCompletionError("Invalid block selection.");

//     try {
//       setSavingProfile(true);

//       // 1) Claim flat in a transaction
//       const communityRef = doc(db, "communities", community.id);
//       await runTransaction(db, async (t) => {
//         const snap = await t.get(communityRef);
//         if (!snap.exists())
//           throw new Error("Community not found during claim.");
//         const data = snap.data();
//         const blocksArr = Array.isArray(data.blocks) ? [...data.blocks] : [];
//         const idx = blocksArr.findIndex((b) => b.id === selectedBlockId);
//         if (idx < 0) throw new Error("Selected block not found.");

//         const target = { ...blocksArr[idx] };
//         const occupancy = { ...(target.occupancy || {}) };
//         if (occupancy[selectedFlatLabel]) {
//           throw new Error(
//             "Selected flat is already occupied. Please choose another flat."
//           );
//         }

//         occupancy[selectedFlatLabel] = auth.currentUser.uid;
//         target.occupancy = occupancy;
//         blocksArr[idx] = target;

//         t.update(communityRef, { blocks: blocksArr });
//       });

//       // 2) Merge user profile
//       const userRef = doc(db, "users", auth.currentUser.uid);
//       const userSnap = await getDoc(userRef);
//       const existing = userSnap.exists() ? userSnap.data() : {};
//       const communities = Array.isArray(existing.communities)
//         ? Array.from(new Set([...(existing.communities || []), community.id]))
//         : [community.id];

//       await setDoc(
//         userRef,
//         {
//           uid: auth.currentUser.uid,
//           role: "resident",
//           email: auth.currentUser.email || existing.email || "",
//           fullName: (fullName || existing.fullName || "").trim() || null,
//           mobile: (mobile || existing.mobile || "").trim() || null,
//           communities,
//           unit: {
//             communityId: community.id,
//             blockName: block.name,
//             floorNumber: selectedFloorNumber,
//             flatLabel: selectedFlatLabel,
//           },
//           status: "pending",
//           profileCompleted: true,
//           pendingCommunityId: null,
//           authProvider:
//             auth.currentUser.providerData?.[0]?.providerId || "unknown",
//           createdAt: existing.createdAt || Timestamp.now(),
//         },
//         { merge: true }
//       );

//       setNeedsCompletion(false);
//       navigate(`/resident/${community.id}`);
//     } catch (err) {
//       console.error("Profile completion error:", err.code, err.message);
//       setCompletionError(
//         err.message || "Could not save your details. Please try again."
//       );
//     } finally {
//       setSavingProfile(false);
//     }
//   };

//   /** Reset */
//   const resetCommunity = () => {
//     setCommunity(null);
//     setCommunityId("");
//     setFetchError("");
//     setShowLoginForm(false);
//     setEmail("");
//     setPassword("");
//     setLoginError("");

//     // reset completion section
//     setProfile(null);
//     setNeedsCompletion(false);
//     setSelectedBlockId("");
//     setSelectedFloorNumber(null);
//     setSelectedFlatLabel("");
//     setAvailableFlats([]);
//     setFullName("");
//     setMobile("");
//     setConfirmInfo(false);
//     setCompletionError("");
//   };

//   return (
//     <Container fluid className="min-vh-100">
//       <Row className="g-0 min-vh-60">
//         {/* LEFT visual (now visible on mobile as a top banner) */}
//         <Col
//           xs={12}
//           md={6}
//           className="login-hero d-flex align-items-center justify-content-center position-relative"
//         >
//           <div className="login-hero-overlay" aria-hidden="true" />
//           <div className="position-relative text-center text-white px-4">
//             <i className="bi bi-shield-lock-fill fs-1 mb-3 d-block"></i>
//             <h2 className="fw-bold">Secure Community Login</h2>
//             <p
//               className="text-white-50 mx-auto hero-sub"
//               style={{ maxWidth: 520 }}
//             >
//               Verify your community, then sign in to access resident services.
//             </p>
//           </div>
//         </Col>

//         {/* RIGHT forms */}
//         <Col
//           xs={12}
//           md={6}
//           className="d-flex align-items-center justify-content-center py-4 py-md-5 bg-light"
//         >
//           <div className="w-100" style={{ maxWidth: 560 }}>
//             {/* Mobile title (optional, you can remove since hero is now visible) */}
//             {/* <div className="mb-4 text-center d-md-none">
//               <i className="bi bi-shield-lock-fill fs-2 d-block"></i>
//               <h2 className="fw-bold mt-2">Secure Community Login</h2>
//               <p className="text-muted mb-0">Identify your community, then sign in.</p>
//             </div> */}

//             {/* Step 1: Community */}
//             <Card className="shadow-sm">
//               <Card.Header className="fw-semibold">
//                 Step 1: Identify Your Community
//               </Card.Header>
//               <Card.Body>
//                 {fetchError && <Alert variant="danger">{fetchError}</Alert>}

//                 {!community ? (
//                   <Form onSubmit={handleFetch}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Community ID</Form.Label>
//                       <Form.Control
//                         type="text"
//                         placeholder="e.g., AVC12345"
//                         value={communityId}
//                         onChange={(e) =>
//                           setCommunityId(e.target.value.toUpperCase())
//                         }
//                         autoFocus
//                       />
//                     </Form.Group>

//                     <div className="d-grid">
//                       <Button
//                         className="btn-primary-navbar-reg"
//                         type="submit"
//                         disabled={fetching}
//                       >
//                         {fetching ? (
//                           <>
//                             <Spinner
//                               animation="border"
//                               size="sm"
//                               className="me-2"
//                             />
//                             Fetching…
//                           </>
//                         ) : (
//                           "Fetch"
//                         )}
//                       </Button>
//                     </div>

//                     <p
//                       className="register-link mt-3"
//                       onClick={() => navigate("/register")}
//                       style={{ cursor: "pointer" }}
//                     >
//                       Register
//                     </p>
//                   </Form>
//                 ) : (
//                   <>
//                     <Alert variant="info">
//                       <div>
//                         <strong>Community ID:</strong>{" "}
//                         <code>{communityId}</code>
//                       </div>
//                       <div>
//                         <strong>Name: {community.data.name}</strong>
//                       </div>
//                       <div>
//                         <strong>Address:</strong> {community.data.address}
//                       </div>
//                       {/* {community.data.description && (
//                         <div>
//                           <strong>Description:</strong> {community.data.description}
//                         </div>
//                       )} */}
//                     </Alert>
//                     <div className="d-flex flex-wrap gap-2">
//                       <Button
//                         variant="outline-secondary"
//                         onClick={resetCommunity}
//                       >
//                         Check another Community
//                       </Button>
//                       <Button
//                         variant="primary"
//                         className="btn-primary-navbar-reg"
//                         onClick={handleProceedToLogin}
//                       >
//                         Proceed to Login
//                       </Button>
//                     </div>
//                   </>
//                 )}
//               </Card.Body>
//             </Card>

//             {/* Step 2: Login */}
//             {community && showLoginForm && !needsCompletion && (
//               <Card className="mt-3 shadow-sm">
//                 <Card.Header className="fw-semibold">
//                   Step 2: Sign In
//                 </Card.Header>
//                 <Card.Body>
//                   {loginError && <Alert variant="danger">{loginError}</Alert>}

//                   <div className="d-grid gap-2 mb-3">
//                     <Button
//                       variant="outline-danger"
//                       onClick={handleGoogleLogin}
//                       disabled={loggingIn}
//                     >
//                       {loggingIn ? (
//                         <>
//                           <Spinner
//                             animation="border"
//                             size="sm"
//                             className="me-2"
//                           />
//                           Signing in…
//                         </>
//                       ) : (
//                         "Continue with Google"
//                       )}
//                     </Button>
//                   </div>

//                   <div className="text-center text-muted my-2">or</div>

//                   <Form onSubmit={handleLogin}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Email</Form.Label>
//                       <Form.Control
//                         type="email"
//                         autoComplete="username"
//                         placeholder="name@example.com"
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                         disabled={!community}
//                       />
//                     </Form.Group>

//                     <Form.Group className="mb-3">
//                       <Form.Label>Password</Form.Label>
//                       <Form.Control
//                         type="password"
//                         autoComplete="current-password"
//                         placeholder="••••••••"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         disabled={!community}
//                       />
//                     </Form.Group>

//                     <div className="d-grid">
//                       <Button
//                         className="btn-primary-navbar-reg"
//                         type="submit"
//                         disabled={!community || loggingIn}
//                       >
//                         {loggingIn ? (
//                           <>
//                             <Spinner
//                               animation="border"
//                               size="sm"
//                               className="me-2"
//                             />
//                             Signing in…
//                           </>
//                         ) : (
//                           "Login"
//                         )}
//                       </Button>
//                     </div>
//                   </Form>
//                 </Card.Body>
//               </Card>
//             )}

//             {/* Step 3: Complete Profile */}
//             {community && needsCompletion && (
//               <Card className="mt-3 shadow-sm">
//                 <Card.Header className="fw-semibold">
//                   Complete your profile
//                 </Card.Header>
//                 <Card.Body>
//                   <Alert variant="warning" className="mb-3">
//                     Please complete your unit details to finish setup for this
//                     community.
//                   </Alert>

//                   {completionError && (
//                     <Alert variant="danger">{completionError}</Alert>
//                   )}

//                   <Row className="g-2">
//                     {/* Block */}
//                     <Form.Group as={Col} xs={12} md={4} className="mb-3">
//                       <Form.Label>Block</Form.Label>
//                       <Form.Select
//                         value={selectedBlockId}
//                         onChange={(e) => {
//                           setSelectedBlockId(e.target.value);
//                           setSelectedFloorNumber(null);
//                           setSelectedFlatLabel("");
//                           setAvailableFlats([]);
//                         }}
//                       >
//                         <option value="">Select block</option>
//                         {blocks.map((b) => (
//                           <option key={b.id} value={b.id}>
//                             {b.name} - Block
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Form.Group>

//                     {/* Floor */}
//                     <Form.Group as={Col} xs={12} md={4} className="mb-3">
//                       <Form.Label>Floor</Form.Label>
//                       <Form.Select
//                         value={selectedFloorNumber ?? ""}
//                         disabled={!selectedBlockId}
//                         onChange={(e) => {
//                           const val =
//                             e.target.value === ""
//                               ? null
//                               : Number(e.target.value);
//                           setSelectedFloorNumber(val);
//                           setSelectedFlatLabel("");
//                           setAvailableFlats([]);
//                         }}
//                         onBlur={refreshAvailableFlats}
//                         onFocus={() => {
//                           if (selectedBlockId && selectedFloorNumber !== null)
//                             refreshAvailableFlats();
//                         }}
//                       >
//                         <option value="">Select floor</option>
//                         {floorOptions.map(({ label, floorNumber }) => (
//                           <option
//                             key={`floor-${floorNumber}`}
//                             value={floorNumber}
//                           >
//                             {label}
//                           </option>
//                         ))}
//                       </Form.Select>
//                       <Form.Text muted>
//                         Ground availability uses the same numbering pattern as
//                         upper floors.
//                       </Form.Text>
//                     </Form.Group>

//                     {/* Flat */}
//                     <Form.Group as={Col} xs={12} md={4} className="mb-3">
//                       <Form.Label>Flat number</Form.Label>
//                       <Form.Select
//                         value={selectedFlatLabel}
//                         disabled={
//                           !selectedBlockId || selectedFloorNumber === null
//                         }
//                         onFocus={refreshAvailableFlats}
//                         onChange={(e) => setSelectedFlatLabel(e.target.value)}
//                       >
//                         <option value="">
//                           {availLoading
//                             ? "Checking availability…"
//                             : "Select available flat"}
//                         </option>
//                         {!availLoading &&
//                           availableFlats.map((label) => (
//                             <option key={label} value={label}>
//                               {label}
//                             </option>
//                           ))}
//                       </Form.Select>
//                     </Form.Group>
//                   </Row>

//                   <hr />

//                   <Form.Group className="mb-3">
//                     <Form.Label>Full name</Form.Label>
//                     <Form.Control
//                       type="text"
//                       value={fullName}
//                       onChange={(e) => setFullName(e.target.value)}
//                       placeholder="e.g., Rahul Sharma"
//                     />
//                   </Form.Group>

//                   <Form.Group className="mb-3">
//                     <Form.Label>Mobile</Form.Label>
//                     <Form.Control
//                       type="text"
//                       value={mobile}
//                       onChange={(e) => setMobile(e.target.value)}
//                       placeholder="e.g., 9876543210"
//                     />
//                   </Form.Group>

//                   <Form.Group className="mb-3">
//                     <Form.Check
//                       id="confirm-info"
//                       type="checkbox"
//                       label="I confirm that the above unit details and my information are correct."
//                       checked={confirmInfo}
//                       onChange={(e) => setConfirmInfo(e.target.checked)}
//                     />
//                   </Form.Group>

//                   <div className="d-grid">
//                     <Button
//                       variant="primary"
//                       onClick={handleCompleteProfile}
//                       disabled={savingProfile}
//                     >
//                       {savingProfile ? (
//                         <>
//                           <Spinner
//                             animation="border"
//                             size="sm"
//                             className="me-2"
//                           />
//                           Saving…
//                         </>
//                       ) : (
//                         "Submit & Continue"
//                       )}
//                     </Button>
//                   </div>
//                 </Card.Body>
//               </Card>
//             )}
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// }

// // ///////////////////////////////////////////////////////////////////////////////
// // above code login with fetching the community id
// // ///////////////////////////////////////////////////////////////////////////////

// src/pages/Login.jsx

import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  sendEmailVerification,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import "./Login.css";

const IMAGE_URL =
  "https://images.unsplash.com/photo-1521783593447-5702f9f80c7a?q=80&w=1600&auto=format&fit=crop";

/**
 * Get registered community ID from the user profile.
 *
 * Supports:
 * 1. unit.communityId used by your current registration
 * 2. communityId if added later
 * 3. communities[0] used by your current registration
 */
const getCommunityIdFromProfile = (userProfile) => {
  const unitCommunityId = userProfile?.unit?.communityId;

  if (unitCommunityId) {
    return String(unitCommunityId).trim();
  }

  if (userProfile?.communityId) {
    return String(userProfile.communityId).trim();
  }

  if (
    Array.isArray(userProfile?.communities) &&
    userProfile.communities.length > 0
  ) {
    return String(userProfile.communities[0]).trim();
  }

  return "";
};

/**
 * Convert Firebase authentication errors into readable messages.
 */
const getLoginErrorMessage = (error) => {
  switch (error?.code) {
    case "auth/invalid-email":
      return "Please enter a valid email address.";

    case "auth/user-disabled":
      return "This account has been disabled. Please contact the administrator.";

    case "auth/user-not-found":
    case "auth/wrong-password":
    case "auth/invalid-credential":
      return "Invalid email or password.";

    case "auth/too-many-requests":
      return "Too many failed login attempts. Please try again later.";

    case "auth/network-request-failed":
      return "Network error. Please check your internet connection.";

    case "auth/popup-closed-by-user":
      return "Google sign-in was cancelled.";

    case "auth/popup-blocked":
      return "Google sign-in popup was blocked. Please allow popups and try again.";

    case "auth/cancelled-popup-request":
      return "Another Google sign-in popup is already open.";

    case "auth/account-exists-with-different-credential":
      return "This email is already registered using a password. Please log in using your email and password.";

    case "auth/operation-not-allowed":
      return "This login method is not enabled. Please contact the administrator.";

    default:
      return error?.message || "Login failed. Please try again.";
  }
};

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loginError, setLoginError] = useState("");
  const [loginInfo, setLoginInfo] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);
  const [resendingVerification, setResendingVerification] = useState(false);

  /**
   * Load Firestore user profile and automatically find the community.
   */
  const routeLoggedInUser = async (firebaseUser) => {
    if (!firebaseUser?.uid) {
      throw new Error("Authenticated user information was not found.");
    }

    const userRef = doc(db, "users", firebaseUser.uid);
    const userSnapshot = await getDoc(userRef);

    if (!userSnapshot.exists()) {
      await signOut(auth);

      throw new Error(
        "Your authentication account exists, but no resident profile was found. Please register first."
      );
    }

    const userProfile = {
      id: userSnapshot.id,
      ...userSnapshot.data(),
    };

    const role = String(userProfile.role || "resident")
      .trim()
      .toLowerCase();

    /*
     * Admin can be global, so community details are not required.
     */
    if (role === "admin") {
      navigate("/admin-dashboard", {
        replace: true,
      });

      return;
    }

    /*
     * Get community from your existing registration fields.
     */
    const communityId = getCommunityIdFromProfile(userProfile);

    if (!communityId) {
      await signOut(auth);

      throw new Error(
        "No community is linked with this account. Please contact the administrator."
      );
    }

    /*
     * Confirm that the linked community still exists.
     */
    const communityRef = doc(db, "communities", communityId);
    const communitySnapshot = await getDoc(communityRef);

    if (!communitySnapshot.exists()) {
      await signOut(auth);

      throw new Error(
        `The linked community "${communityId}" was not found. Please contact the administrator.`
      );
    }

    /*
     * Your registration sends email verification.
     *
     * Keep this check if the resident must verify the email before accessing
     * the resident dashboard.
     */
    if (
      role === "resident" &&
      firebaseUser.providerData.some(
        (provider) => provider.providerId === "password"
      ) &&
      !firebaseUser.emailVerified
    ) {
      navigate(
        `/check-email?community=${encodeURIComponent(
          communityId
        )}&email=${encodeURIComponent(firebaseUser.email || "")}`,
        {
          replace: true,
        }
      );

      return;
    }

    /*
     * Validate resident registration data.
     */
    if (role === "resident") {
      const profileCompleted =
        userProfile.profileCompleted === true;

      const hasUnit =
        Boolean(userProfile.unit) &&
        Boolean(userProfile.unit.communityId) &&
        Boolean(userProfile.unit.flatLabel);

      if (!profileCompleted || !hasUnit) {
        await signOut(auth);

        throw new Error(
          "Your resident profile is incomplete. Please contact the administrator or complete registration."
        );
      }

      navigate(`/resident/${encodeURIComponent(communityId)}`, {
        replace: true,
      });

      return;
    }

    if (role === "manager") {
      navigate(`/manager/${encodeURIComponent(communityId)}`, {
        replace: true,
      });

      return;
    }

    if (role === "employee") {
      navigate(`/employee/${encodeURIComponent(communityId)}`, {
        replace: true,
      });

      return;
    }

    await signOut(auth);

    throw new Error(
      `The account role "${role}" is not supported. Please contact the administrator.`
    );
  };

  /**
   * Email and password login.
   */
  const handleEmailLogin = async (event) => {
    event.preventDefault();

    setLoginError("");
    setLoginInfo("");

    const cleanEmail = email.trim().toLowerCase();

    if (!cleanEmail) {
      setLoginError("Please enter your email address.");
      return;
    }

    if (!password) {
      setLoginError("Please enter your password.");
      return;
    }

    try {
      setLoggingIn(true);

      const userCredential =
        await signInWithEmailAndPassword(
          auth,
          cleanEmail,
          password
        );

      /*
       * Reload Firebase user so emailVerified is current.
       */
      await userCredential.user.reload();

      await routeLoggedInUser(userCredential.user);
    } catch (error) {
      console.error(
        "Email login error:",
        error?.code,
        error?.message,
        error
      );

      setLoginError(getLoginErrorMessage(error));
    } finally {
      setLoggingIn(false);
    }
  };

  /**
   * Google login.
   *
   * Important:
   * This works when the Google UID has a matching users/{uid} document.
   */
  const handleGoogleLogin = async () => {
    setLoginError("");
    setLoginInfo("");

    try {
      setLoggingIn(true);

      const provider = new GoogleAuthProvider();

      provider.setCustomParameters({
        prompt: "select_account",
      });

      const result = await signInWithPopup(auth, provider);

      await routeLoggedInUser(result.user);
    } catch (error) {
      console.error(
        "Google login error:",
        error?.code,
        error?.message,
        error
      );

      setLoginError(getLoginErrorMessage(error));
    } finally {
      setLoggingIn(false);
    }
  };

  /**
   * Optional resend verification function.
   */
  const handleResendVerification = async () => {
    setLoginError("");
    setLoginInfo("");

    if (!auth.currentUser) {
      setLoginError(
        "Please log in with your email and password before resending verification."
      );
      return;
    }

    if (auth.currentUser.emailVerified) {
      setLoginInfo("Your email is already verified.");
      return;
    }

    try {
      setResendingVerification(true);

      const userRef = doc(db, "users", auth.currentUser.uid);
      const userSnapshot = await getDoc(userRef);

      if (!userSnapshot.exists()) {
        throw new Error("User profile was not found.");
      }

      const userProfile = userSnapshot.data();
      const communityId =
        getCommunityIdFromProfile(userProfile);

      const actionCodeSettings = {
        url: communityId
          ? `${window.location.origin}/verify-success?community=${encodeURIComponent(
              communityId
            )}`
          : `${window.location.origin}/verify-success`,
        handleCodeInApp: false,
      };

      await sendEmailVerification(
        auth.currentUser,
        actionCodeSettings
      );

      setLoginInfo(
        "Verification email sent successfully. Please check your inbox and spam folder."
      );
    } catch (error) {
      console.error(
        "Resend verification error:",
        error?.code,
        error?.message,
        error
      );

      setLoginError(
        error?.message ||
          "Could not resend verification email."
      );
    } finally {
      setResendingVerification(false);
    }
  };

  return (
    <Container fluid className="min-vh-100 p-0">
      <Row className="g-0 min-vh-100">
        {/* Left visual */}
        <Col
          xs={12}
          md={6}
          className="login-hero d-flex align-items-center justify-content-center position-relative"
          style={{
            backgroundImage: `url("${IMAGE_URL}")`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
        >
          <div
            className="login-hero-overlay"
            aria-hidden="true"
          />

          <div className="position-relative text-center text-white px-4">
            <i className="bi bi-shield-lock-fill fs-1 mb-3 d-block" />

            <h2 className="fw-bold">
              Secure Community Login
            </h2>

            <p
              className="text-white-50 mx-auto"
              style={{ maxWidth: 520 }}
            >
              Log in using your registered account. Your
              community and unit details will be loaded
              automatically.
            </p>
          </div>
        </Col>

        {/* Right login form */}
        <Col
          xs={12}
          md={6}
          className="d-flex align-items-center justify-content-center bg-light px-3 py-4"
        >
          <div
            className="w-100"
            style={{ maxWidth: 520 }}
          >
            <Card className="shadow-sm rounded-4">
              <Card.Header className="fw-semibold py-3">
                Login
              </Card.Header>

              <Card.Body className="p-3 p-md-4">
                <p className="text-muted">
                  Enter your registered email and password.
                  You do not need to enter the Community ID
                  again.
                </p>

                {loginError && (
                  <Alert variant="danger">
                    {loginError}
                  </Alert>
                )}

                {loginInfo && (
                  <Alert variant="success">
                    {loginInfo}
                  </Alert>
                )}

                {/* Google login */}
                <div className="d-grid mb-3">
                  <Button
                    type="button"
                    variant="outline-danger"
                    onClick={handleGoogleLogin}
                    disabled={
                      loggingIn || resendingVerification
                    }
                  >
                    {loggingIn ? (
                      <>
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                        Signing in...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-google me-2" />
                        Continue with Google
                      </>
                    )}
                  </Button>
                </div>

                {/* <div className="text-center text-muted my-3">
                  or
                </div> */}

                {/* Email/password login */}
                {/* <Form onSubmit={handleEmailLogin}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>

                    <Form.Control
                      type="email"
                      value={email}
                      onChange={(event) =>
                        setEmail(event.target.value)
                      }
                      placeholder="name@example.com"
                      autoComplete="username"
                      disabled={loggingIn}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>

                    <Form.Control
                      type="password"
                      value={password}
                      onChange={(event) =>
                        setPassword(event.target.value)
                      }
                      placeholder="Enter your password"
                      autoComplete="current-password"
                      disabled={loggingIn}
                    />
                  </Form.Group>

                  <div className="d-grid">
                    <Button
                      type="submit"
                      className="btn-primary-navbar-reg"
                      disabled={
                        loggingIn || resendingVerification
                      }
                    >
                      {loggingIn ? (
                        <>
                          <Spinner
                            animation="border"
                            size="sm"
                            className="me-2"
                          />
                          Signing in...
                        </>
                      ) : (
                        "Login"
                      )}
                    </Button>
                  </div>
                </Form> */}

                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2 mt-3">
                  <Button
                    type="button"
                    variant="link"
                    className="p-0"
                    onClick={() =>
                      navigate("/register")
                    }
                    disabled={loggingIn}
                  >
                    New resident? Register
                  </Button>

                  {auth.currentUser &&
                    !auth.currentUser.emailVerified && (
                      <Button
                        type="button"
                        variant="link"
                        className="p-0"
                        onClick={handleResendVerification}
                        disabled={
                          resendingVerification ||
                          loggingIn
                        }
                      >
                        {resendingVerification
                          ? "Sending..."
                          : "Resend verification"}
                      </Button>
                    )}
                </div>
              </Card.Body>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
}